// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__k6hMN","lightBackground":"Footer_lightBackground__fYySo","darkBackground":"Footer_darkBackground__xPebh","listHeading":"Footer_listHeading__3oca-"};